<script>
    import date from './../lib/date';

    import Layout from '../layout/simple.svelte';

    import EventModal from '../modals/event.svelte';
    import ReservationModal from '../modals/reservation.svelte';

    import Timetable from '../ui/timetable.svelte';
    import WeekSelect from '../ui/weekselect.svelte';

    import Surveys from './home/surveys.svelte';

    import events from '../state/events.js';
    import user from '../state/user.js';
    import modals from '../state/modals.js';
    import surveys from '../state/surveys.js';

    // Get current year, week
    const curDate = new Date();
    let weekStartDate = date.startOfWeek(curDate);

    // Load logged-in user data
    user.load();

    // Load events for current week
    events.load(weekStartDate);

    window.Sentry && Sentry.setContext('datepicker', {
        date: date.format(weekStartDate, date.FORMAT_DATE_ISO8601)
    });

    function onWeekChanged(e) {
        weekStartDate = e.detail;

        // Load events for selected week
        events.load(weekStartDate);

        window.Sentry && Sentry.setContext('datepicker', {
            date: date.format(weekStartDate, date.FORMAT_DATE_ISO8601)
        });
    }

    // Get alert message
    let message = null;

    getMessage();

    async function getMessage() {
        // Try to get messages from announcements API
        let resp = null;

        try {
            resp = await fetch('/api/announcements').then(resp => resp.json());
        } catch (error) {
            console.error('Failed to fetch announcements!');
        }

        // Failed or no messages
        if (!resp || !resp.announcements || !resp.announcements.length) return message = null;

        // Got announcements
        let messages = resp.announcements;

        // Get messages that the user already seen
        let hiddenMessages = getHiddenMessages();

        for (let msg of messages) {
            if (hiddenMessages[msg.ann_id]) continue;

            return message = {
                id: msg.ann_id,
                contents: msg.ann_message
            };
        }

        return message = null;
    }

    function getHiddenMessages() {
        let hiddenMessages = localStorage.getItem('hidden-messages');

        if (hiddenMessages) {
            return JSON.parse(hiddenMessages);
        }

        return {};
    }

    function hideMessage(i) {
        let hiddenMessages = getHiddenMessages();
        hiddenMessages[i] = true;

        localStorage.setItem('hidden-messages', JSON.stringify(hiddenMessages));

        if (message && message.id == i) message = null;
    }
</script>

<style>
    .toolbar {
        padding: 8px;
    }

    .contents {
        flex: 1;
        padding: 10px;
        background: #f7f7f7;
    }

    .toolbar + .notification {
        margin: 0;
    }

    .notification .delete {
        width: 30px;
        max-width: 30px;
        height: 30px;
        max-height: 30px;
    }
</style>

<Layout page="home">
    <div class="toolbar">
        <WeekSelect weekStartDate={weekStartDate} on:week-selected={onWeekChanged} />
    </div>

    {#if message}
        <div class="notification is-warning">
            <button class="delete" on:click="{() => { hideMessage(message.id) }}"></button>
            {@html message.contents}
        </div>
    {/if}

    {#if $surveys && $surveys.length}
        <Surveys surveys={$surveys} />
    {/if}

    <div class="contents">
        <Timetable events={$events} weekStartDate={weekStartDate} />
    </div>

    <EventModal />
    <ReservationModal />
</Layout>